export const StringsMapping = {
  All_Change: _TL_('All changes'),
  Top_Decliners: _TL_('Top decliners'),
  Top_Gainers: _TL_('Top gainers'),
  EmptyState_Title: _TL_('Track your conversions'),
  EmptyState_Subtitle: _TL_('Visit the conversion tracking and UET dashboard pages to start creating conversion goals that will track your conversions and revenue.'),
  EmptyState_Action: _TL_('Set up conversion tracking'),

  Footer_ManageConversions: _TL_('Manage Conversion Goals'),
  Footer_PageCount: _TL_('Page {{pageNumber}} of 2', 'text in {{}} must NOT be translated'),

  Status_Title: _TL_('You have conversion tracking status errors that need to be fixed'),
  Status_Subtitle: _TL_('Visit the Conversion goals page to identify issues with your goals to get them back on track.'),
  Status_Alert: _TL_('Alert'),
  Status_RecentConversions: _TL_(' with no recent conversions', 'preserve one space at the beginning'),
  Status_RecordingConversions: _TL_(' with revenue attribute set', 'preserve one space at the beginning'),
  Status_Inactive: _TL_(' with inactive tags', 'preserve one space at the beginning'),
  Status_Unverified: _TL_(' with unverified tags', 'preserve one space at the beginning'),
  Status_Unavailable: _TL_(' with inactive due to unavailable tags', 'preserve one space at the beginning'),

  Coupon_Title: _TL_('Get {{value}} when you set up a conversion goal.'),

  Coupon_Step1: _TL_('{{b}}Step 1{{/b}}: Set up a conversion goal', 'text in between {{b}} {{/b}} is bolded'),
  Coupon_Step2: _TL_('{{b}}Step 2{{/b}}: ', 'text in between {{b}} {{/b}} is bolded'),
  Coupon_Step2_Detail: _TL_('Spend {{cost}} on your campaigns and you’ll automatically receive {{value}} in advertising credit.', 'text in {{}} must NOT be translated'),

  Number_Of_Goals: _TL_('{{number}} goals', 'text in {{}} must NOT be translated'),

  StatusMessage_InactiveDueToTagUnavailable: _TL_('The account no longer has access to the UET tag. Permissions to a UET tag in another manager account may have been removed, or this account was transferred and lost permission to a UET tag in a previous manager account.'),
  StatusMessage_NoRecentConversion: _TL_("We've seen your UET tag, but haven't recorded any conversions in the last 7 days. This is most likely because you either have created the goal incorrectly, have not tagged your entire website, especially the pages that have the conversion action or you don't have any users converting on your site."),
  StatusMessage_RecordingConversions: _TL_("We've seen your UET tag and have recorded conversions within the last 7 days. If your conversion window is greater than 7 days and you are filtering on the last 7 days, you may see this status even if no conversions are shown in the Conversions column, as conversions are reported at the time of the click."),
  StatusMessage_TagInactive: _TL_("We haven't received any user activity data from your UET tag in the last 24 hours. Make sure that the UET tag tracking code is still on your website."),
  StatusMessage_Unverified: _TL_("We haven't received any user activity data from the UET tag on your website. It can take up to 24 hours for us to verify. If you still see this status, you either have not added the UET tag tracking code to your website or there is an issue with the setup that you need to fix."),


  NoRecentConversion: _TL_('No recent conversions'),
  RecordingConversions: _TL_('No revenue attribute sets'),
  InactiveTag: _TL_('Inactive tags'),
  UnverifiedTag: _TL_('Unverified tags'),
  UnavailableTag: _TL_('Unavailable tags'),

  NoReveueText: _TL_("None of your conversion goals are tracking revenue. This means that you haven't associated any specific revenue value to your goals. Tracking revenue is a great way of measuring the revenue gained from advertisers converting on your ad campaign."),
  See_All: _TL_('See all'),
  Learn_More: _TL_('Learn more'),

  Hover_Change: _TL_('Change: {{value}} ({{percentageValue}})', 'text in {{}} must NOT be translated'),
  Empty_Data: _TL_('{{b}}No data available.{{/b}} To update the tile, select a different date range. If the tile remains blank, your account might have no data.'),
};

export const GoalCategory = {
  AddToCart: _TL_('Add to cart'),
  BeginCheckout: _TL_('Begin checkout'),
  BookAppointment: _TL_('Book appointment'),
  Contact: _TL_('Contact'),
  GetDirections: _TL_('Get directions'),
  InStoreVisit: _TL_('Store visit'),
  None: _TL_('Unassigned'),
  Other: _TL_('Other'),
  OutboundClick: _TL_('Outbound click'),
  PageView: _TL_('Page view'),
  Purchase: _TL_('Purchase'),
  RequestQuote: _TL_('Request quote'),
  Signup: _TL_('Sign - up'),
  Subcribe: _TL_('Subscribe'),
  SubmitLeadForm: _TL_('Submit lead form'),
};

export const metrici18nKeys = {
  ConversionsCredit: _TL_('Conversions: {{value}}', 'text in {{}} must NOT be translated'),
  AdvertiserReportedRevenue: _TL_('Revenue: {{value}}', 'text in {{}} must NOT be translated'),
};
